import { GetStaticProps } from 'next';
/* APIs */
import { reviews } from '@api/apis';
/* Constants */
import { PAGE_TYPE_CUSTOMER_REVIEWS } from '@constants/pages';
import { SEVEN_DAYS } from '@constants/CacheRevalidate';
/* Types */
import { Children } from 'types/base.types';
import { ReviewsPageResponse } from 'types/reviews.types';
/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import CustomerReviewsPage from '@scenes/CustomerReviewsPage';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';

function CustomerReviews(props: ReviewsPageResponse): Children {
  return (
    <>
      <Head>{generateNextSeo({ title: 'Customer Reviews' })}</Head>
      <CustomerReviewsPage {...props} />
    </>
  );
}

export const getStaticProps: GetStaticProps = async context => {
  /* Get plans data */
  const response = await reviews.reviewsPage().then(r => r.data);

  if (!response.reviews || response.errors) {
    throw new Error('No reviews found');
  }

  return {
    props: {
      reviews: response.reviews,
    },
    revalidate: SEVEN_DAYS,
  };
};

CustomerReviews.pageAttributes = { page: PAGE_TYPE_CUSTOMER_REVIEWS };
CustomerReviews.Layout = getLayout({ promo: true, footer: true });

export default CustomerReviews;
